<template>
  <div class="max-w-[700px] px-5 flex flex-col gap-2 pb-5">

    <p>Mit unserem TimeTravel-Feature können Sie die Zeit zurückdrehen und einzelne Seiten wiederherstellen!
   Suchen Sie sich einfach den gewünschten Zeitpunkt aus und klicken Sie auf "Wiederherstellen".
    Oder erstellen Sie einen neuen Zeitpunkt, indem Sie auf "Zeitpunkt erstellen" klicken.</p>


    <div class="w-full">
      <table class="w-full text-left">
        <tr>
          <th class="w-1/4">Datum</th>
          <th>Titel</th>
          <th class="w-1/4">Aktion</th>
        </tr>
        <tr v-for="timeTravelPoint in timeTravelPoints" :key="timeTravelPoint.timeTravelPointId">
          <td>{{ unixToDate(timeTravelPoint.timestamp) }}</td>
          <td>{{ timeTravelPoint.title }}</td>

          <td>
            <button @click="restoreTimeTravelPoint(timeTravelPoint.timeTravelPointId)"
                    class="bg-trader-red text-trader-dark-red p-2 hover:bg-trader-hover-background hover:text-trader-hover-text w-full"
            >Wiederherstellen
            </button>
          </td>
        </tr>

        <tr class="h-5">
          <td colspan="3"></td>
        </tr>

        <tr class="text-left">
          <td colspan="3" class="font-bold">Neuen Zeitpunkt erstellen</td>
        </tr>

        <tr>
          <td colspan="2" >
          <input v-model="title" type="text" placeholder="Geben Sie einen Titel für den neuen Zeitpunkt ein"
                 class="w-full border border-gray-300 rounded p-2">
          </td>
          <td><button @click="createTimeTravelPoint(title)"
                      class="bg-trader-green text-trader-dark-green w-full py-2 hover:bg-trader-hover-background hover:text-trader-hover-text"
          >Zeitpunkt erstellen
          </button></td>
        </tr>

      </table>
    </div>

    <div class="w-full flex gap-2">

      <button @click="close" data-ui="close-time-travel"
              class="bg-trader-gray w-full p-2 hover:bg-trader-hover-background hover:text-trader-hover-text"
      >Schließen
      </button>
    </div>
  </div>
</template>

<script>


import apolloClient from "@/apolloClient";
import {gql} from "@apollo/client/core";
import ProductHeader from "@/components/ProductFormular/ProductHeader.vue";
import {eventBus} from "@/application/EventBus";


export default {
  components: {ProductHeader},
  props: {
    pageId: {
      type: Number,
      default: null
    },
    reloadPage: {
      type: Function,
      default: () => {
      }
    }
  },
  data() {
    return {
      title: '',
      timeTravelPoints: [],
    }
  },
  mounted() {
    this.getTimeTravelPoints();
  },
  methods: {
    close() {
      eventBus.closeModal();
    },

    unixToDate(unix) {
      const date = new Date(unix * 1000);
      return date.toLocaleString();
    },

    //createTimeTravelPoint(pageId: Int!, title: String!) : Success!
    async createTimeTravelPoint(title) {
      const mutation = gql`
        mutation createTimeTravelPoint($pageId: Int!, $title: String!) {
          createTimeTravelPoint(pageId: $pageId, title: $title) {
            success
          }
        }
      `;

      apolloClient.mutate({
        mutation,
        variables: {pageId: this.pageId, title: title}
      }).then(() => {
        this.getTimeTravelPoints();
      });
    },

    restoreTimeTravelPoint(timeTravelPointId) {
      const mutation = gql`
        mutation restoreTimeTravelPoint($timeTravelPointId: Int!) {
          restoreTimeTravelPoint(timeTravelPointId: $timeTravelPointId) {
            success
          }
        }
      `;

      apolloClient.mutate({
        mutation,
        variables: {timeTravelPointId}
      }).then(() => {
        this.reloadPage();

      });
    },

    async getTimeTravelPoints() {

      const query = gql`
        query getTimeTravelPoints($pageId: Int!) {
          getTimeTravelPoints(pageId: $pageId)  {
            pageId
            timestamp
            timeTravelPointId
            title
          }
        }
      `;
      try {
        const {data} = await apolloClient.query({
          query,
          variables: {pageId: this.pageId}
        });
        this.timeTravelPoints = data.getTimeTravelPoints;
      } catch (error) {
        console.error(error);
      }
    },
  },
}


</script>